import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    container: {
      padding: '10px',
      gap: '12px',
    },
    text: {
      fontSize: 14,
    },
    testButtons: {
      margin: 'auto',

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
    },
    buttonsBase: {
      borderTop: `1px solid ${palette.borderGray}`,
      justifyContent: 'right',
      paddingTop: 10,
    },
    buttonsAlign: {
      justifyContent: 'flex-end',
      display: 'flex',
      paddingBottom: 5,
    },
    viewIcon: {
      width: 15,
      height: 15,
    },

    addButtonCompanyContext: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navCompanyContextActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navCompanyContextActions,
        color: palette.white,
      },
    },
    addButtonAdmin: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navAdminActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navAdminActions,
        color: palette.white,
      },
    },
    addButtonOperator: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navOperatorActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navOperatorActions,
        color: palette.white,
      },
    },
    addButtonSuperAdmin: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navSuperAdminActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navSuperAdminActions,
        color: palette.white,
      },
    },
    radioGroup: {
      display: 'flex',
      alignSelf: 'center',
      flexDirection: 'row',

      '& .MuiTypography-root': {
        fontSize: 14,
      },
    },

    clientsTable: {
      margin: '12px 0 10px 0',
      width: '100%',
    },
    likeCell: {
      width: 20,
      padding: 0,
      textAlign: 'center',

      '& svg': {
        fontSize: 14,
        fill: palette.primary.main,
      },
    },
    clientSelected: {
      '& .MuiTableCell-root': {
        fontWeight: 600,
        lineHeight: 0,
      },
    },
    clientCell: {
      cursor: 'pointer',
      padding: '0px 0px 0px 16px',
      '& .MuiTableCell-root': {
        paddingLeft: 0,
      },
      '& .MuiTypography-root': {
        fontSize: 12,
      },
    },
    tableRow: {
      height: 20,
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
      },
    },
    boldText: {
      fontWeight: 'bold',
      fontSize: 12,
    },

    titleGrid: {
      padding: 8,
      border: `1px solid ${palette.lightGray}`,
      borderRadius: 8,
    },
    titleGridError: {
      border: `1px solid ${palette.red}`,
    },
  });
